(() => {
  const shippingFormatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Istanbul",
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
    hourCycle: "h23"
  });
  const dispatchDateFormatter = new Intl.DateTimeFormat("tr-TR", {
    timeZone: "UTC", day: "numeric", month: "long", weekday: "long"
  });
  const shippingExceptions = { "2026-10-28": 12, "2026-10-29": null };
  const getShippingSchedule = (now, cutoffHour = 16) => {
    const parts = {};
    shippingFormatter.formatToParts(now).forEach(({ type, value }) => {
      if (type !== "literal") parts[type] = Number(value);
    });
    const nowWallClock = Date.UTC(parts.year, parts.month - 1, parts.day,
      parts.hour, parts.minute, parts.second, now.getUTCMilliseconds());
    let day = Date.UTC(parts.year, parts.month - 1, parts.day);
    let targetWallClock;
    while (targetWallClock === undefined) {
      const date = new Date(day);
      const dateKey = date.toISOString().slice(0, 10);
      const weekday = date.getUTCDay();
      const hour = Object.prototype.hasOwnProperty.call(shippingExceptions, dateKey)
        ? shippingExceptions[dateKey] : cutoffHour;
      const candidate = day + hour * 60 * 60 * 1000;
      if (weekday !== 0 && weekday !== 6 && hour !== null && candidate > nowWallClock) {
        targetWallClock = candidate;
      } else {
        day += 24 * 60 * 60 * 1000;
      }
    }
    const target = new Date(targetWallClock);
    const targetHour = String(target.getUTCHours()).padStart(2, "0") + ".00";
    const holidayNotice = nowWallClock >= Date.UTC(2026, 9, 28)
      && nowWallClock < Date.UTC(2026, 9, 30)
      ? "29 Ekim'de kargo çıkışı yoktur. " : "";
    return {
      remainingSeconds: Math.max(0, Math.ceil((targetWallClock - nowWallClock) / 1000)),
      message: holidayNotice + "Sonraki kargo: "
        + dispatchDateFormatter.format(target) + " " + targetHour + "."
    };
  };

  const init = (root) => {
    if (!root || root.dataset.sgbReady === 'true') return;
    root.dataset.sgbReady = 'true';

    const gallery = root.querySelector('.sgb-gallery');
    const mainImage = gallery && gallery.querySelector('.sgb-main-image img');
    const thumbnails = gallery ? Array.from(gallery.querySelectorAll('.sgb-thumbnail')) : [];
    if (mainImage && thumbnails.length) {
      const imageKey = (value) => {
        try {
          const url = new URL(value, window.location.href);
          url.searchParams.delete('width');
          return url.origin + url.pathname + url.search;
        } catch (error) {
          return value;
        }
      };
      const originalImageKey = imageKey(mainImage.currentSrc || mainImage.src);
      const updateSelection = (selected) => {
        thumbnails.forEach((thumbnail) => {
          const active = thumbnail === selected;
          thumbnail.setAttribute('aria-pressed', String(active));
          thumbnail.classList.toggle('is-active', active);
        });
      };
      const activateThumbnail = (thumbnail) => {
        const image = thumbnail.querySelector('img');
        if (!image) return;
        const source = new URL(image.currentSrc || image.src, window.location.href);
        source.searchParams.set('width', '1400');
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = source.toString();
        mainImage.alt = image.alt || thumbnail.getAttribute('aria-label') || 'Ürün görseli';
        updateSelection(thumbnail);
      };
      thumbnails.forEach((thumbnail, index) => {
        const image = thumbnail.querySelector('img');
        const label = image && image.alt ? image.alt.trim() : 'Ürün görseli ' + (index + 1);
        const sourceKey = image ? imageKey(image.currentSrc || image.src) : '';
        const isActive = sourceKey && sourceKey === originalImageKey;
        thumbnail.setAttribute('role', 'button');
        thumbnail.setAttribute('tabindex', '0');
        thumbnail.setAttribute('aria-label', label);
        thumbnail.setAttribute('aria-pressed', String(isActive));
        thumbnail.classList.toggle('is-active', Boolean(isActive));
        thumbnail.addEventListener('click', () => activateThumbnail(thumbnail));
        thumbnail.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activateThumbnail(thumbnail);
          }
        });
      });
    }

    root.querySelectorAll('[data-sgb-stone]').forEach((select) => {
      const field = select.closest('.sgb-stone-field');
      const preview = field && field.querySelector('[data-sgb-preview]');
      const title = field && field.querySelector('[data-sgb-preview-title]');
      const details = field && field.querySelector('[data-sgb-preview-details]');
      const image = field && field.querySelector('[data-sgb-preview-image]');
      const updatePreview = () => {
        const option = select.selectedOptions[0];
        if (!preview || !option || !option.value) {
          if (preview) preview.hidden = true;
          return;
        }
        preview.hidden = false;
        if (title) title.textContent = option.dataset.title || option.textContent.trim();
        if (details) details.textContent = option.dataset.details || '';
        if (image) {
          if (option.dataset.image) {
            image.src = option.dataset.image;
            image.hidden = false;
          } else {
            image.removeAttribute('src');
            image.hidden = true;
          }
        }
      };
      select.addEventListener('change', updatePreview);
      updatePreview();
    });

    const stoneSelects = Array.from(root.querySelectorAll('[data-sgb-stone]'));
    const stoneChoiceButtons = Array.from(root.querySelectorAll('[data-sgb-stone-option]'));
    const status = root.querySelector('[data-sgb-stone-status]');
    const syncStoneChoiceButtons = () => {
      stoneChoiceButtons.forEach((button) => {
        const blockId = button.dataset.sgbStoneOption;
        const selected = stoneSelects.some((select) => select.selectedOptions[0] && select.selectedOptions[0].dataset.blockId === blockId);
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('is-selected', selected);
      });
    };
    const chooseStoneForNextSlot = (button) => {
      const blockId = button.dataset.sgbStoneOption;
      const matchingSelections = stoneSelects.filter((select) => select.selectedOptions[0] && select.selectedOptions[0].dataset.blockId === blockId);
      if (matchingSelections.length) {
        const target = matchingSelections[matchingSelections.length - 1];
        const option = target.selectedOptions[0];
        const selectionNumber = stoneSelects.indexOf(target) + 1;
        target.selectedIndex = 0;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        if (status) {
          status.textContent = (option.dataset.title || option.textContent.trim()) + ' ' + selectionNumber + '. taş kutusundan kaldırıldı.';
          status.hidden = false;
        }
        syncStoneChoiceButtons();
        return;
      }
      const target = stoneSelects.find((select) => !select.value);
      if (!target) {
        if (status) {
          status.textContent = 'Dört taş seçimi dolu. Değiştirmek için seçim kutularını kullanın.';
          status.hidden = false;
        }
        return;
      }
      const option = Array.from(target.options).find((item) => item.dataset.blockId === blockId);
      if (!option) return;
      target.selectedIndex = Array.from(target.options).indexOf(option);
      target.dispatchEvent(new Event('change', { bubbles: true }));
      if (status) {
        status.textContent = (option.dataset.title || option.textContent.trim()) + ' ' + (stoneSelects.indexOf(target) + 1) + '. taş kutusuna eklendi.';
        status.hidden = false;
      }
      syncStoneChoiceButtons();
    };
    stoneChoiceButtons.forEach((button) => {
      button.addEventListener('click', () => chooseStoneForNextSlot(button));
      // Native buttons trigger click for Enter and Space.

    });
    stoneSelects.forEach((select) => select.addEventListener('change', syncStoneChoiceButtons));
    syncStoneChoiceButtons();

    const variantSelect = root.querySelector('[data-sgb-variant]');
    const price = root.querySelector('[data-sgb-price]');
    const submit = root.querySelector('[data-sgb-submit]');
    const submitLabel = root.querySelector('[data-sgb-submit-label]');
    if (variantSelect) {
      const updateVariant = () => {
        const option = variantSelect.selectedOptions[0];
        if (price && option) price.textContent = option.dataset.price || '';
        if (submit && option) {
          const available = option.dataset.available === 'true';
          submit.disabled = !available;
          if (submitLabel) submitLabel.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldOutLabel;
        }
      };
      variantSelect.addEventListener('change', updateVariant);
      updateVariant();
    }


    const countdowns = root.querySelectorAll('[data-sgb-countdown]');
    const updateCountdowns = () => {
      const now = new Date();
      countdowns.forEach((clock) => {
        const configuredHour = Number(clock.dataset.cutoffHour || 16);
        const cutoffHour = Number.isInteger(configuredHour) && configuredHour >= 0 && configuredHour <= 23
          ? configuredHour : 16;
        const schedule = getShippingSchedule(now, cutoffHour);
        const totalSeconds = schedule.remainingSeconds;
        const dispatch = clock.nextElementSibling?.querySelector("span");
        if (dispatch && dispatch.textContent !== schedule.message) dispatch.textContent = schedule.message;
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        const output = clock.querySelector('[data-sgb-countdown-time]');
        if (output) output.textContent = hours + ':' + minutes + ':' + seconds;
      });
    };
    if (countdowns.length) {
      updateCountdowns();
      if (root._sgbCountdownTimer) window.clearInterval(root._sgbCountdownTimer);
      root._sgbCountdownTimer = window.setInterval(updateCountdowns, 1000);
    }
  };

  document.querySelectorAll('[data-sgbundle]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[data-sgbundle]'));
  });
})();
